// avstemming-period-messages translations (Spanish catalog).
window.PlummeI18n.register('es', {
  'avhp.common.countOf': '{done} de {total}',
  'avhp.common.summary': '{done} de {total} tratados · {passed} superados · {deviations} desviaciones',
  'avhp.common.conclusion': 'Conclusión',
  'avhp.common.cancel': 'Cancelar',
  'avhp.common.open': 'Abrir',
  'avhp.common.hidePassed': 'Ocultar superadas',
  'avhp.common.hide': 'Ocultar',
  'avhp.common.responsible': 'Responsable',
  'avhp.common.status': 'Estado',
  'avhp.common.area': 'Área',
  'avhp.common.amount': 'Importe',
  'avhp.common.deadline': 'Plazo',
  'avhp.common.type': 'Tipo',
  'avhp.common.notAvailable': 'No disponible',
  'avhp.common.sec.crossChecks': 'Controles cruzados',
  'avhp.common.sec.analytics': 'Control analítico',
  'avhp.common.sec.tasks': 'Tareas y desviaciones',
  'avhp.common.sec.reporting': 'Informes',
  'avhp.common.sec.areas': 'Áreas de conciliación',
  'avhp.common.sec.checklist': 'Lista de comprobación',
  'avhp.common.sum.areasWithDeviation': 'Áreas con desviaciones',
  'avhp.common.sum.accountsNoDocs': 'Cuentas sin documentación',
  'avhp.common.sum.openItems': 'Partidas de conciliación abiertas',
  'avhp.common.sum.activeTasks': 'Tareas activas',
  'avhp.common.sum.unexplainedAnalytics': 'Desviaciones analíticas sin explicación',
  'avhp.common.professionalChecklist': 'Lista de comprobación profesional',
  'avhp.common.issues.one': '{count} asunto',
  'avhp.common.issues.other': '{count} asuntos',
  'avhp.cp.notAssessed': 'Sin evaluar',
  'avhp.cp.ok': 'OK',
  'avhp.cp.remark': 'Observación',
  'avhp.cp.mustFix': 'Debe corregirse',
  'avhp.ck.source': 'Fuente y evidencia: {source}',
  'avhp.ck.critical': 'Crítico',
  'avhp.ck.rationaleRequired': 'Se requiere justificación',
  'avhp.ck.rationale': 'Justificación',
  'avhp.ck.deviationPlaceholder': '¿Cuál es la desviación y qué se hace al respecto?',
  'avhp.ck.waiting': ' · {count} en espera',
  'avhp.ck.blocked': ' · {count} bloqueados',
  'avhp.ck.controller': 'Revisor',
  'avhp.ck.reviewerPointsDone': '{done} de {total} puntos del revisor tratados',
  'avhp.ck.reviewerNote': 'Los puntos se responden en la pestaña de revisión del panel derecho, por alguien distinto de quien hizo el trabajo.',
  'avhp.ck.reviewerLocked': 'Disponible tras el envío a revisión. Los puntos del revisor no pueden tratarse mientras el período siga en trabajo por parte del preparador.',
  'avhp.cl.title': 'Conclusión y aprobación',
  'avhp.cl.areasDone': 'Áreas de conciliación completadas',
  'avhp.cl.untreatedPoints': 'Puntos de control sin tratar',
  'avhp.cl.overallStatus': 'Estado general',
  'avhp.cl.approvedLocked': 'Aprobado y bloqueado',
  'avhp.cl.ready': 'Listo para revisión',
  'avhp.cl.notReady': 'No está listo para revisión',
  'avhp.cl.openArea': 'Abrir área',
  'avhp.cl.conclusionHint': 'Un período sin una sola palabra sobre lo que se hizo no está revisado: solo está abierto.',
  'avhp.cl.remainingRisk': 'Riesgo restante',
  'avhp.cl.followUpNext': 'Seguimiento del próximo período',
  'avhp.cl.performedBy': 'Realizado por',
  'avhp.cl.checkedBy': 'Revisado por',
  'avhp.cl.saveConclusion': 'Guardar conclusión',
  'avhp.cl.sendTitle': 'Envía todo el período a revisión por parte de alguien distinto de ti.',
  'avhp.cl.sendTitleBlockedOne': 'El período puede enviarse a revisión, pero aún queda {count} asunto pendiente.',
  'avhp.cl.sendTitleBlockedMany': 'El período puede enviarse a revisión, pero aún quedan {count} asuntos pendientes.',
  'avhp.cl.sendToReview': 'Enviar a revisión',
  'avhp.cl.approvalNote': 'La aprobación la realiza el revisor en la pestaña de revisión, no desde aquí.',
  'avhp.cl.lastSaved': 'Guardado por última vez el {date}',
  'avhp.cl.savedBy': ' por {email}',
  'avhp.cl.periodLock': 'Bloqueo del período',
  'avhp.cl.lockNote': 'El bloqueo limita los cambios en el período. Reabrirlo requiere una justificación, que queda en el registro de actividad.',
  'avhp.cl.reopenPeriod': 'Reabrir el período',
  'avhp.cl.lockPeriod': 'Bloquear el período',
  'avhp.sec.crossChecksNote': 'Controles que abarcan varias áreas de conciliación.',
  'avhp.sec.showPassed': 'Mostrar {count} superadas',
  'avhp.sec.controlRule': 'Regla de control',
  'avhp.sec.dataSources': 'Fuentes de datos',
  'avhp.sec.result': 'Resultado',
  'avhp.sec.deviation': 'Desviación',
  'avhp.sec.outcome': 'Resultado final',
  'avhp.sec.confirm': 'Confirmar',
  'avhp.sec.confirmedBy': 'Confirmado por {name}',
  'avhp.sec.completeness': 'Integridad y período correcto',
  'avhp.sec.completenessNote': 'Plumme sugiere qué partidas conviene evaluar, pero no concluye automáticamente que sean erróneas. Para las filas marcadas como «no disponible», Plumme todavía no tiene ninguna fuente: no se han comprobado hasta quedar a cero.',
  'avhp.sec.noBasisData': 'Faltan datos para esta comparación',
  'avhp.sec.analyticsNote': 'Las cifras proceden del balance de comprobación. Que una desviación sea material lo determinan conjuntamente el importe, el límite de materialidad, la variación histórica y la explicación conocida: no solo el porcentaje y no Plumme.',
  'avhp.sec.thisPeriod': 'Este período',
  'avhp.sec.comparison': 'Comparación',
  'avhp.sec.deviationKr': 'Desviación (kr)',
  'avhp.sec.deviationPct': 'Desviación (%)',
  'avhp.sec.explanation': 'Explicación',
  'avhp.sec.grossProfit': 'Beneficio bruto / margen',
  'avhp.sec.marginNote': 'Los ingresos y el coste de las mercancías deben evaluarse conjuntamente: el margen puede caer aunque el beneficio bruto aumente en coronas.',
  'avhp.sec.notExplained': 'Sin explicar',
  'avhp.sec.editExplanation': 'Editar explicación',
  'avhp.sec.registerExplanation': 'Registrar explicación',
  'avhp.sec.explanationHint': 'Obligatorio. Una comparación sin una palabra sobre el porqué no es una evaluación.',
  'avhp.sec.documentationOptional': 'Documentación (opcional)',
  'avhp.sec.voucherPlaceholder': 'Número de justificante o nota',
  'avhp.sec.actionFollowUp': 'Medida / seguimiento del próximo período',
  'avhp.sec.saveExplanation': 'Guardar explicación',
  'avhp.sec.noResultLines': 'No hay líneas de resultados en el período que comparar. Si aún no se han contabilizado ingresos ni gastos, no hay evolución que analizar.',
  'avhp.sec.tasksNote': 'Una tarea es una medida sobre una única partida de conciliación de un área, no una copia de ella. Al resolver la medida cambia la partida de origen y la tarea desaparece de aquí por sí sola.',
  'avhp.sec.priority': 'Prioridad',
  'avhp.sec.sourceAreaItem': 'Área de origen / partida',
  'avhp.sec.description': 'Descripción',
  'avhp.sec.waitingForCustomer': 'En espera del cliente',
  'avhp.sec.markResolved': 'Marcar como resuelta',
  'avhp.sec.closedElsewhere': 'Se cierra donde corresponde',
  'avhp.sec.resultHint': 'Obligatorio para marcar la tarea como resuelta: el texto se guarda en la partida de conciliación de origen.',
  'avhp.sec.resolvedBy': 'Resuelta por',
  'avhp.sec.confirmResolved': 'Confirmar resolución',
  'avhp.sec.noTasks': 'No hay medidas abiertas en el período. Las tareas surgen cuando alguien escribe una medida en una partida de conciliación de un área.',
  'avhp.sec.reportsNote': 'Los plazos solo se muestran cuando Plumme tiene una fuente para ellos. Un plazo sin fuente parecería igual de fiable que uno que la tiene. Plumme no presenta nada sin aprobación.',
  'avhp.sec.reportObligation': 'Informe / obligación',
  'avhp.sec.appliesToPeriod': 'Período al que se aplica',
  'avhp.sec.dataBasis': 'Base de datos',
  'avhp.sec.notRegistered': 'Sin registrar',
  'avhp.pg.modelNotLoaded': 'El modelo de lectura de los controles del período no se ha cargado.',
  'avhp.pg.overview': 'Resumen',
  'avhp.pg.unexplained': '{count} sin explicar',
  'avhp.pg.explained': 'Explicado',
  'avhp.pg.activeCount': '{count} activas',
  'avhp.pg.ready': 'Listo',
  'avhp.pg.blocked': 'Bloqueado',
  'avhp.pg.noOwnBalance': 'sin saldo propio: el estado se toma de las demás áreas',
  'avhp.pg.title': 'Controles del período',
  'avhp.pg.dataThrough': ' · Datos hasta el {date} inclusive',
  'avhp.pg.responsible': ' · Responsable {name}',
  'avhp.pg.materialityLabel': ' · Límite de materialidad ',
  'avhp.pg.notSet': 'sin definir',
  'avhp.pg.areaLimitsDiffer': ' (los límites específicos de cada área pueden diferir)',
  'avhp.pg.dataVersionTitle': 'Todos los estados, sumas y bloqueos de esta página se leen de la misma contabilidad y de las mismas conciliaciones.',
  'avhp.pg.basisLine': 'Base: el balance de comprobación y las conciliaciones tal como están ahora',
  'avhp.pg.areasProcessed': '{done} de {total} áreas relevantes se han tratado por completo.',
  'avhp.pg.blockersOne': '{count} asunto bloquea la finalización del período.',
  'avhp.pg.blockersMany': '{count} asuntos bloquean la finalización del período.',
  'avhp.pg.noBlockers': 'Nada bloquea la finalización del período.',
  'avhp.pg.preliminary': '{period} no ha terminado. Este es un control provisional del período a fecha {date}: el libro mayor definitivo y los datos de integración deben volver a leerse tras el cierre del período.',
  'avhp.pg.overallOverview': 'Resumen general del período',
  'avhp.pg.kpiRelevant': 'Áreas de conciliación relevantes',
  'avhp.pg.kpiDone': 'Tratadas por completo',
  'avhp.pg.hintOpenItems': 'Un asunto identificado en un área de conciliación. No es lo mismo que una tarea.',
  'avhp.pg.kpiUnposted': 'Documentos sin contabilizar en la bandeja de entrada',
  'avhp.pg.hintUnposted': 'Incluye documentos que se han leído pero no contabilizado; no se cuentan por separado. Aparece como una tarea propia en la lista de tareas.',
  'avhp.pg.hintActiveTasks': 'Una actividad concreta que debe resolver una partida de conciliación. Una medida distinta de las partidas abiertas.',
  'avhp.pg.progress': 'Avance del trabajo: {pct} % tratado',
  'avhp.pg.hideCalc': 'Ocultar cálculo',
  'avhp.pg.showCalc': 'Mostrar cálculo',
  'avhp.pg.progressNote': 'Mide cuánto se ha revisado, no cuánto se ha superado. Un punto tratado aún puede tener desviaciones.',
  'avhp.pg.readyYes': 'Listo para informar: Sí',
  'avhp.pg.readyNoOne': 'Listo para informar: No — queda {count} asunto',
  'avhp.pg.readyNoMany': 'Listo para informar: No — quedan {count} asuntos',
  'avhp.pg.finalStateNote': 'Estado final calculado: no se ve afectado por que se traten más puntos con desviaciones.',
  'avhp.pg.progressExplain': 'El avance del trabajo es la proporción de los puntos de control de la lista de comprobación profesional que se han tratado: {done} de {total}. Los puntos derivados del sistema cuentan cuando tienen una respuesta; los profesionales solo cuentan cuando alguien se ha pronunciado sobre ellos. Los puntos tratados con desviaciones cuentan para el avance, pero no hacen que el período esté listo para informar.',
  'avhp.pg.autoMasterControls': 'Controles principales derivados automáticamente',
  'avhp.pg.showPassedAuto': 'Mostrar {count} controles automáticos superados',
  'avhp.pg.areasNote': 'El estado se toma de la conciliación de cada área: aquí no se marca nada manualmente. Haz clic en una fila para abrir el área.',
  'avhp.pg.scope': 'Alcance',
  'avhp.pg.materialBalance': 'Saldo/desviación material',
  'avhp.pg.openItems': 'Partidas abiertas',
  'avhp.pg.documentation': 'Documentación',
  'avhp.pg.lastUpdated': 'Última actualización',
  'avhp.pg.openArea': 'Abrir {area}',
});
